import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { useEffect } from 'react';
import { formatCompactNumber } from '@/core/utils/numbers/format-compact-number';
import useGetSourceStats from '../../hooks/useGetSourceStats.hook';
import { useAnalytics } from '../../hooks/useAnalytics.hook';
import ListSkeleton from '../skeletons/ListSkeleton';
import { cn } from '@/core/utils/cn';
import { decodeDotKey } from '@/core/utils/encode-decode';

type SourceItem = { source: string; count: number };

const SourceMetrics = () => {
  const { state } = usePlayground();
  const { dateFilter, filters, updateFilter } = useAnalytics();
  const getSourceStats = useGetSourceStats();

  useEffect(() => {
    if (!state.payload?._id) return;

    getSourceStats.mutate({
      link_in_bio_id: state.payload._id,
      start_date: dateFilter.start,
      end_date: dateFilter.end,
      ...filters,
    });
  }, [state.payload?._id, dateFilter, filters]);

  if (!getSourceStats.data) return <ListSkeleton />;

  const filteredData = filters.source
    ? getSourceStats.data.data.filter((item: SourceItem) => item.source === filters.source)
    : getSourceStats.data.data;

  return (
    <div className="w-full">
      <p className="text-lighter text-sm font-medium mb-4">Sources</p>

      <div className="flex flex-col gap-y-1">
        {filteredData.length ? (
          filteredData.map((item: SourceItem) => {
            const decodedSource = decodeDotKey(item.source);
            const match = decodedSource.match(/^([^\[]+)\[([^\]]+)\]$/) || '';

            return (
              <div
                className={cn(
                  'flex items-center justify-between px-3 py-1.5 cursor-pointer rounded-md',
                  filters.source === item.source ? 'bg-dark' : '',
                )}
                onClick={() => {
                  if (filters.source === item.source) return;
                  updateFilter('source', item.source);
                }}
              >
                <span className="text-lighter text-sm font-medium flex items-center">
                  {match[2] ? <img className="mr-2 w-4 h-4" src={match[2]} /> : null} {match ? match[1] : decodedSource}
                </span>
                <span className="text-lighter text-sm font-medium">{formatCompactNumber(item.count)}</span>
              </div>
            );
          })
        ) : (
          <span className="text-lighter">-</span>
        )}
      </div>
    </div>
  );
};

export default SourceMetrics;
